import { BaseElement } from 'base';
import { bus } from 'bus';
import { runAction } from 'run-action';

class InlineMessage extends BaseElement {
  #action = null;
  #box = null;
  #close = null;
  #content = null;

  onConnect() {
    this.#box = this.q(':scope > .message');
    this.#close = this.q('.message__close');
    this.#content = this.q('.message__content');
    this.topic = this.dataset.topic || '';

    if (this.#close) {
      this.#close.disabled = this.disabled;
      this.listen(this.#close, 'click', this.#onClose);
    }
    if (this.topic) this.subscribe(this.topic, this.#onTopic);
  }

  get visible() {
    return Boolean(this.#box) && !this.#box.hidden;
  }

  get text() {
    return this.#content?.textContent ?? '';
  }

  set text(value) {
    if (this.#content) this.#content.textContent = String(value);
  }

  get disabled() {
    return this.dataset.disabled === 'true';
  }

  set disabled(value) {
    const isDisabled = Boolean(value);
    if (this.#close) {
      if (
        isDisabled &&
        this.#close.getRootNode().activeElement === this.#close
      ) {
        this.#box.tabIndex = -1;
        this.#box.focus();
      }
      this.#close.disabled = isDisabled;
    }
    if (isDisabled) {
      this.dataset.disabled = 'true';
    } else {
      delete this.dataset.disabled;
    }
  }

  run(action) {
    this.#action = action;
    return this;
  }

  show() {
    this.#request(true);
  }

  hide() {
    this.#request(false);
  }

  #request(visible) {
    if (this.topic) {
      bus.publish(this.topic, visible);
    } else {
      this.#render(visible);
    }
  }

  #onTopic(value) {
    if (typeof value !== 'boolean') {
      console.error(
        `[message] "${this.topic}" expects a boolean, received:`,
        value
      );
      return;
    }
    this.#render(value);
  }

  #render(visible) {
    if (!this.#box || visible === this.visible) return;
    this.#box.hidden = !visible;
  }

  #onClose() {
    if (this.disabled) return;
    this.#request(false);
    runAction(
      this,
      this.#action,
      { reason: 'dismiss', id: this.id },
      'message'
    );
  }
}

if (!customElements.get('inline-message'))
  customElements.define('inline-message', InlineMessage);
